import '../scss/app.scss';
// or get all of the named exports for further usage
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

console.log("ready");



import './main.js'
import './cookies.js'
